import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { CheckCircle, Loader2 } from 'lucide-react';
import { Layout } from '../components/layout/Layout';
import { useAuth } from '../contexts/AuthContext';
import { API_BASE } from '../config/api';

const API = `${API_BASE}/api`;

export default function PaymentSuccessPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { token } = useAuth();
  const [loading, setLoading] = useState(true);
  const [paymentStatus, setPaymentStatus] = useState(null);

  const paymentId = searchParams.get('payment_id');

  useEffect(() => {
    const checkPayment = async () => {
      if (!paymentId || !token) {
        setLoading(false);
        return;
      }

      try {
        const res = await axios.get(`${API}/payment/status/${paymentId}`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        setPaymentStatus(res.data);
      } catch (error) {
        console.error('Payment status error:', error);
      } finally {
        setLoading(false);
      }
    };

    checkPayment();
  }, [paymentId, token]);

  return (
    <Layout>
      <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 py-16 text-center">
        {loading ? (
          <div className="flex flex-col items-center">
            <Loader2 className="h-12 w-12 text-navigate-gold animate-spin mb-4" />
            <p className="text-zinc-400">Verifying payment...</p>
          </div>
        ) : (
          <>
            <div className="w-20 h-20 bg-green-500/20 rounded-full flex items-center justify-center mx-auto mb-6">
              <CheckCircle className="h-10 w-10 text-green-400" />
            </div>
            
            <h1 className="text-3xl font-bold text-white mb-4">Payment Successful!</h1>
            
            <p className="text-zinc-400 mb-8">
              Thank you for your purchase. You now have access to the course.
            </p>

            {paymentStatus && (
              <div className="bg-navigate-surface border border-zinc-800 rounded-xl p-6 mb-8 text-left">
                <h3 className="font-semibold text-white mb-4">Payment Details</h3>
                <div className="space-y-2 text-sm">
                  <div className="flex justify-between">
                    <span className="text-zinc-400">Payment ID:</span>
                    <span className="text-white">{paymentStatus.payment_id}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-zinc-400">Amount:</span>
                    <span className="text-navigate-gold font-semibold">
                      R {paymentStatus.amount?.toLocaleString('en-ZA', { minimumFractionDigits: 2 })}
                    </span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-zinc-400">Status:</span>
                    <span className="text-green-400 capitalize">{paymentStatus.status}</span>
                  </div>
                </div>
              </div>
            )}

            <div className="flex gap-4 justify-center">
              <button
                onClick={() => navigate('/my-courses')}
                className="btn-gold"
              >
                Go to My Courses
              </button>
              <button
                onClick={() => navigate('/courses')}
                className="px-6 py-3 bg-zinc-800 text-white rounded-lg hover:bg-zinc-700 transition-colors"
              >
                Browse More Courses
              </button>
            </div>
          </>
        )}
      </div>
    </Layout>
  );
}
